import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SupplyChain, Node, Edge } from '../../types';
import { api } from '../api';

interface SupplyChainState {
  selectedNodeId: string | null;
  selectedEdgeId: string | null;
  filterOptions: {
    nodeTypes: string[];
    riskLevel: string | null;
    region: string | null;
  };
  viewMode: 'map' | 'graph' | 'table';
}

const initialState: SupplyChainState = {
  selectedNodeId: null,
  selectedEdgeId: null,
  filterOptions: {
    nodeTypes: [],
    riskLevel: null,
    region: null,
  },
  viewMode: 'graph',
};

const supplyChainSlice = createSlice({
  name: 'supplyChain',
  initialState,
  reducers: {
    selectNode: (state, action: PayloadAction<string | null>) => {
      state.selectedNodeId = action.payload;
      state.selectedEdgeId = null;
    },
    selectEdge: (state, action: PayloadAction<string | null>) => {
      state.selectedEdgeId = action.payload;
      state.selectedNodeId = null;
    },
    setNodeTypeFilter: (state, action: PayloadAction<string[]>) => {
      state.filterOptions.nodeTypes = action.payload;
    },
    setRiskLevelFilter: (state, action: PayloadAction<string | null>) => {
      state.filterOptions.riskLevel = action.payload;
    },
    setRegionFilter: (state, action: PayloadAction<string | null>) => {
      state.filterOptions.region = action.payload;
    },
    setViewMode: (state, action: PayloadAction<'map' | 'graph' | 'table'>) => {
      state.viewMode = action.payload;
    },
    clearFilters: (state) => {
      state.filterOptions = {
        nodeTypes: [],
        riskLevel: null,
        region: null,
      };
    },
  },
  extraReducers: (builder) => {
    // When a supply chain is successfully fetched, reset selections
    builder.addMatcher(
      api.endpoints.getSupplyChain.matchFulfilled,
      (state) => {
        state.selectedNodeId = null;
        state.selectedEdgeId = null;
      }
    );
  },
});

export const {
  selectNode,
  selectEdge,
  setNodeTypeFilter,
  setRiskLevelFilter,
  setRegionFilter,
  setViewMode,
  clearFilters,
} = supplyChainSlice.actions;

export default supplyChainSlice.reducer;
